import React, { Component } from "react"
import { compose } from "redux"
import { LazyLoadImage } from "react-lazy-load-image-component"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"

//component
import TimeAgo from "./TimeAgo"
import { get_user_function } from "../containers/Function/OtherUserInfo.function"
import ImageProfile from "./ImageProfile"
import * as project_actions from "../actions/action_project"
import { replaceURL } from "../containers/Function/Url.function"
import * as notification_actions from "../actions/action_notification"
import { NotificationManage } from "./NotificationManage"

//material ui
import ListItem from "@material-ui/core/ListItem"
import ListItemText from "@material-ui/core/ListItemText"
import ListItemAvatar from "@material-ui/core/ListItemAvatar"
import Avatar from "@material-ui/core/Avatar"
import Typography from "@material-ui/core/Typography"

class Notification extends Component {
	constructor(props) {
		super(props)
		this.state = {
			userPostInfo: null,
			Owner: "",
			seen: true,
			body: null,
			title: "",
			statusproject: true
		}
	}
	componentDidMount() {
		this.handlesetstate(this.props)
	}
	UNSAFE_componentWillReceiveProps(nextProps) {
		this.handlesetstate(nextProps)
	}
	handlesetstate = async (props) => {
		if (Object.keys(this.props.user).length !== 0) {
			const { option } = props

			if (!!option.from) {
				get_user_function(option.from, this.props.user)
					.then((userPostInfo) => {
						if (Object.keys(userPostInfo).length === 0) {
							this.setState({
								Owner: `User not found`,
								userPostInfo
							})
						} else {
							this.setState({
								Owner: `${userPostInfo.given_name} ${userPostInfo.family_name}`,
								userPostInfo
							})
						}
					})
					.catch((getUserError) =>
						get_user_function(option.from, this.props.user)
							.then((userPostInfo) => {
								if (Object.keys(userPostInfo).length === 0) {
									this.setState({
										Owner: `User not found`,
										userPostInfo
									})
								} else {
									this.setState({
										Owner: `${userPostInfo.given_name} ${userPostInfo.family_name}`,
										userPostInfo
									})
								}
							})
							.catch((err) => {})
					)
				if (option.notification_title === "followUser") {
					let notification_body = JSON.parse(option.notification_body)
					this.setState({ body: notification_body })
				} else if (option.notification_title === "Contect from email") {
					let notification_body = JSON.parse(option.notification_body)
					this.setState({ body: notification_body })
				} else {
					let notification_body = JSON.parse(option.notification_body)
					await this.props
						.getprojectnoti(notification_body.project_id)
						.then((res) => {
							this.setState({
								body: res.value.data.getProject.data[0],
								statusproject: true
							})
						})
						.catch((err) => {
							let notification_body = JSON.parse(option.notification_body)
							this.setState({ body: notification_body, statusproject: false })
						})
				}
				this.setState({
					title: this.renderType(option),
					seen: option.seen
				})
			}
		}
	}
	renderType = (option) => {
		switch (option.notification_title) {
			case "like":
				return "liked"
			case "createComment":
				return "commented on"
			case "favoriteProject":
				return "favorited"
			case "Contect from email":
				return "sent email to you"
			case "followUser":
				return "started following you"
			case "addToMyProject":
				return "cloned"
			case "updateProject":
				return "updated"
			case "createProject":
				return "created"
			default:
				return ""
		}
	}
	handleListItemClick = async (e, body, option, t) => {
		e.preventDefault()
		if (!option.seen) {
			await this.props.seen_notification(option.notification_id)
			this.setState({
				seen: this.props.option.seen
			})
		}
		if (this.state.statusproject) {
			if (option.notification_title === "followUser") {
				this.props.history.push(`/UserProfile/${body.following_user}`)
			} else if (option.notification_title === "Contect from email") {
				this.props.history.push(`/UserProfile/${body.user_id}`)
			} else {
				const url = replaceURL(
					body.project_keyword,
					body.project_source,
					body.research_area
				)
				let pathname = window.location.pathname.split("/")
				if (pathname[1] === "ProjectOverview") {
					this.props.history.push(
						body.project_source === "-"
							? `/ProjectOverviews/${url.Keyword}/${url.ResearchArea}/${body.project_id}`
							: `/ProjectOverviews/${url.Keyword}/${url.Source}/${url.ResearchArea}/${body.project_id}`
					)
				} else if (pathname[1] === "ProjectOverviews") {
					this.props.history.push(
						body.project_source === "-"
							? `/ProjectOverview/${url.Keyword}/${url.ResearchArea}/${body.project_id}`
							: `/ProjectOverview/${url.Keyword}/${url.Source}/${url.ResearchArea}/${body.project_id}`
					)
				} else {
					this.props.history.push(
						body.project_source === "-"
							? `/ProjectOverview/${url.Keyword}/${url.ResearchArea}/${body.project_id}`
							: `/ProjectOverview/${url.Keyword}/${url.Source}/${url.ResearchArea}/${body.project_id}`
					)
				}
			}
		} else {
			NotificationManage(
				"info",
				`${t("community.removed")}`,
				`${t("NotificationManager.status.info")}`
			)
		}
	}
	render() {
		const { i, classes, handleopen, option, t } = this.props
		const { Owner, seen, body, title, userPostInfo } = this.state
		return (
			title.length !== 0 &&
			!!body && (
				<ListItem
					key={i}
					button
					selected={!seen}
					onClick={(event) => {
						this.handleListItemClick(event, body, option, t)
						handleopen(i)
					}}
					alignItems="flex-start"
					style={{ whiteSpace: "normal", borderRadius: 0 }}
				>
					<ListItemAvatar>
						<Avatar alt="notification">
							{userPostInfo && userPostInfo.image ? (
								<ImageProfile
									userInfoImage={userPostInfo.image}
									width="40px"
									height="40px"
								/>
							) : (
								<LazyLoadImage
									alt="userInfo"
									src="/login.png"
									width="40px"
									height="40px"
								/>
							)}
						</Avatar>
					</ListItemAvatar>
					<ListItemText
						style={{ paddingRight: 0 }}
						primary={
							<React.Fragment>
								<Typography className={classes.inline} color="textPrimary">
									{Owner}
								</Typography>{" "}
								{title}{" "}
								{(option.notification_title !== "Contect from email" ||
									option.notification_title !== "followUser") && (
									<Typography className={classes.inline} color="textPrimary">
										{body.project_name}
									</Typography>
								)}{" "}
							</React.Fragment>
						}
						secondary={<TimeAgo date={option.date_time} />}
					/>
				</ListItem>
			)
		)
	}
}
function mapStateToProps(reduxState) {
	return {
		user: reduxState.UserReducer.user,
		userInfo: reduxState.UserReducer.userInfo
	}
}
const mapDispatchToProps = function (dispatch) {
	return {
		getprojectnoti: (projectId) =>
			dispatch(project_actions.getprojectnoti(projectId)),
		seen_notification: (notification_id) =>
			dispatch(notification_actions.seen_notification(notification_id))
	}
}
export default compose(
	connect(mapStateToProps, mapDispatchToProps),
	withRouter
)(Notification)
